import { render, staticRenderFns } from "./CustomizerProperty.vue?vue&type=template&id=44d59b3a&"
import script from "./CustomizerProperty.vue?vue&type=script&lang=js&"
export * from "./CustomizerProperty.vue?vue&type=script&lang=js&"
import style0 from "./CustomizerProperty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports